/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getPaycardTypeByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetPaycardTypeById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getPaycardTypeByIdIdRegExpTwo)]).optional()
});

export type GetPaycardTypeById = zod.input<typeof GetPaycardTypeById>;
export type GetPaycardTypeByIdOutput = zod.output<typeof GetPaycardTypeById>;
